/** 
 * Use as external script from public-api folder
 * requires jquery
 */

import '../../../scss/booking-widget/v1/booking-widget.scss';
import { init as init_token } from 'data/token';
import { init as init_button } from 'booking-widget/v1/gc-button';
 
 (function ( $ ) {
     $.fn.booking_widget_gc_button = function(options) {
        if (typeof options === 'undefined') {
            options = {};
        }

        let context_el = this;
        let opts = $.extend({
            context_el: context_el,
            set_parameters: false, // function that returns {tour_id: x, adult_count: x child_count: x}
            on_loaded: function() {},
            on_book: function(amounts) {
                default_op();
            }
        }, options);

        if (!opts.set_parameters || (typeof opts.set_parameters !== 'function')) {
            return this;
        }

        $.when(init_token()).then(function() {
            // do whatever now
             init_button(opts);
        });

        return context_el;
     }
 }( jQuery ));